import { axiosPost, axiosPut } from 'shared/api/axios'
import { AxiosError } from 'axios'
import { apiUrls } from 'consts'
import displayGenError from 'shared/utils/displayGenError'
import setFormValidationError from 'shared/utils/setFormValidationError'

interface submitFormProps {
  data: any
  setShowOverlay: Function
  id: string | undefined
  setError: Function
}

const submitForm = async (props: submitFormProps) => {
  let response: any = false

  props.data['parent_filter_id'] = props.data['parentFilter']?.id ?? ''
  props.data['display_select_all'] = props.data['is_multi'] ? (props.data['display_select_all'] ? 1 : 0) : null
  props.data['select_all_is_default'] = props.data['is_multi'] ? (props.data['select_all_is_default'] ? 1 : 0) : null
  props.data['select_all_label'] = props.data['is_multi'] ? props.data['select_all_label'] : null
  props.data['select_all_value'] = props.data['is_multi'] ? props.data['select_all_value'] : null
  props.data['is_multi'] = props.data['is_multi'] ? 1 : 0

  props.data['sync'] = props.data['sync'] ? 1 : 0
  props.data['connection_id'] = props.data['connection']?.id ?? ''
  props.data['table_name'] = props.data['table_name']
  props.data['sync_type'] = props.data['syncType']?.id ?? ''


  delete props.data['connection']

  const formData = {
    ...props.data,
  }

  const catchFunc = (err: AxiosError) => {
    if (err.response!.status === 422) {
      const mappedAttributes: Map<string, string> = new Map()
      mappedAttributes.set('syncType', 'sync_type')
      mappedAttributes.set('param', 'param')
      setFormValidationError(err, props.setError, mappedAttributes, 'name')
    } else {
      displayGenError({ setShowOverlay: props.setShowOverlay })
    }
  }

  if (props.id === undefined) {
    response = await axiosPost(apiUrls.filters, formData, catchFunc)
  } else {
    response = await axiosPut(apiUrls.filters + '/' + props.id, formData, catchFunc)
  }
  return response
}

export default submitForm
